import * as React from "react";
import cs from "classnames";
// UI Frameworks
import { Input as AntdInput } from "antd";
import { InputProps } from "antd/lib/input";
// Styles
import styles from "./index.module.scss";

interface IProps extends InputProps {
	children?: React.ReactNode;
}
const Input: React.FC<IProps> = ({ className, children, ...restProps } : any, ref) => {
	return (
		<AntdInput {...restProps} className={cs(styles.input, className)} ref={ref}>
			{children}
		</AntdInput>
	);
};

// @ts-ignore
export default React.forwardRef(Input);
